export const usePlatformStore = defineStore('platform', () => {
  const api = useApi()

  const platformMetrics = ref<PlatformMetric[]>([])

  const citiesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'citiesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const companiesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'companiesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const companiesInMillions = computed(() => {
    return Math.ceil(companiesCount.value / (1 * 1000 * 1000)) || 1
  })

  const continentsCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'continentsCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const countiesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'countiesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const countriesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'countriesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const industriesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'industriesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const industriesNaicsCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'industriesNaicsCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const industriesSicCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'industriesSicCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const jobTitlesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'jobTitlesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const locationsCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'locationsCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const sourcesCount = computed(() => {
    return 56
  })

  const statesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'statesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const technologiesCount = computed(() => {
    const metric = platformMetrics.value.find((metric) => {
      return metric.name === 'technologiesCount'
    })

    return Number.parseInt(metric?.value || '0')
  })

  const fetchMetrics = async () => {
    try {
      const { data: platformMetricsFetched } = await api.platform.metrics.fetch()

      if (platformMetricsFetched) {
        platformMetrics.value = platformMetricsFetched
      }
    }
    catch (error) {
      return Promise.reject(error)
    }

    return platformMetrics.value
  }

  return {
    citiesCount,
    companiesCount,
    companiesInMillions,
    continentsCount,
    countiesCount,
    countriesCount,
    fetchMetrics,
    industriesCount,
    industriesNaicsCount,
    industriesSicCount,
    jobTitlesCount,
    locationsCount,
    platformMetrics,
    sourcesCount,
    statesCount,
    technologiesCount,
  }
})
